import session from './session'
import {ENDPOINT} from './index'

export default {
  create (data) {
    return session.post(ENDPOINT + '/sysconfig/create_company_log/', data)
  },
  update (formData) {
    return session.post(ENDPOINT + '/sysconfig/update_company_log/', formData)
  },
  remove (id) {
    return session.post(ENDPOINT + '/sysconfig/delete_company_log/', {id: id})
  },
  get (company_id) {
    return session.post(ENDPOINT + '/sysconfig/get_company_log/', {company_id: company_id})
  },
  upload (formData) {
    const photos = formData.getAll('photos')
    const promises = photos.map((x) => this.getImage(x)
      .then(img => ({
        id: img,
        originalName: x.name,
        fileName: x.name,
        url: img
      })))
    return Promise.all(promises)
  },
  getImage (file) {
    return new Promise((resolve, reject) => {
      const fReader = new FileReader()
      const img = document.createElement('img')
      fReader.readAsDataURL(file)
      fReader.onload = (e) => {
        img.src = fReader.result
        resolve(img.src)
      }
    })
  },
  getBase64Image (img) {
    const canvas = document.createElement('canvas')
    canvas.width = img.width
    canvas.height = img.height
    const ctx = canvas.getContext('2d')
    ctx.drawImage(img, 0, 0)
    return canvas.toDataURL()
  }
}



// WEBPACK FOOTER //
// ./src/api/companyLogo.js